import { render, staticRenderFns } from "./investmentFollowDetail.vue?vue&type=template&id=1e13b41f&scoped=true&"
import script from "./investmentFollowDetail.vue?vue&type=script&lang=js&"
export * from "./investmentFollowDetail.vue?vue&type=script&lang=js&"
import style0 from "./investmentFollowDetail.vue?vue&type=style&index=0&id=1e13b41f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e13b41f",
  null
  
)

export default component.exports